export const getImageAspectRatio = () => {
  //TODO(consolidation): fix this for web
  return 4 / 3
}
